<template>
    <el-dialog
      :title="'新增'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" label-width="105px">
        <div class="form_item">
          <el-form-item label="用户id:" style="width:400px;">
            <el-input v-model="editParam.uid"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="handleClose" style="margin-right:50px;">取 消</el-button>
        <el-button type="primary" @click="handleOK()" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      editParam: {
        uid: undefined,
      }
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.editParam.uid = undefined;
      this.flag = false;
    },
    // 确认修改
    handleOK() {
        this.flag = true;
        this.submitEdit();
    },
    // 提交修改
    submitEdit() {
      let params = {
        uid: parseInt(this.editParam.uid),
        autoFollow: true
      };
      API.editUser(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$parent.search()
          } else {
            this.$message.error("添加失败");
          }
          this.flag = false;
          this.handleClose();
        })
        .catch(() => {
          this.flag = false;
          this.handleClose();
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
</style>
